/**
 * @file "Hand over to…" for a device Abra doesn't have yet (an IRU / Meraki /
 * testing-sheet orphan). Submits a `register` gear action: Finance gets the
 * usual hand-over ping, creates the asset and assigns it, and the pending row
 * reconciles by serial once the Flexi record lands. Shared by the device page
 * and Reconcile so both behave identically.
 *
 * The picker opens pre-searched for the MDM owner, so the common case — the
 * person IRU already says has it — is one tap.
 */

import { toast } from '../utils.js';
import { openEmployeePicker } from '../employee-picker.js';
import { submitGearAction } from '../api.js';

/** Who the MDM / testing sheet says has the device, if anyone. */
export function mdmOwnerEmail(device) {
  return device?.iru?.ownerEmail || device?.meraki?.ownerEmail || device?.testing?.usedByEmail || null;
}

export function promptRegisterHandover(device) {
  const owner = mdmOwnerEmail(device);
  openEmployeePicker({
    title:        `Hand over ${device.name || 'device'}`,
    subtitle:     owner ? `MDM: ${owner}` : null,
    confirmLabel: 'Hand over',
    initialQuery: owner || '',
    onPick: async (employee) => {
      try {
        const res = await submitGearAction({
          action: 'register',
          deviceId: device.id, // the orphan doc — its pages show the pending row until the Flexi doc takes over
          payload: {
            device:   { name: device.name || null, sn: device.sn, category: device.category || null },
            toHolder: { employeeId: employee.id, name: employee.fullName || null, email: employee.email || null },
          },
        });
        if (res?.slack?.ok) toast('Handed over. Finance notified.', 'success');
        else toast(`Handed over, but the Slack ping failed (${res?.slack?.error || res?.slack?.reason || 'unknown'}). Retrying automatically.`, 'error', 8000);
      } catch (err) {
        console.error('[register] hand-over failed', err);
        toast(err.message || 'Hand-over failed.', 'error');
        throw err; // keeps the picker open so the admin can retry
      }
    },
  });
}
